import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=005bfc5a&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=005bfc5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005bfc5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/src/Web/InternetBranch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005bfc5a')) {
      api.createRecord('005bfc5a', component.options)
    } else {
      api.reload('005bfc5a', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=005bfc5a&scoped=true", function () {
      api.rerender('005bfc5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout.vue"
export default component.exports